import * as z from "zod";

export const generatePdfForBill = {
  name: "generatePdfForBill" as const,
  input: z.object({ billId: z.string() }),
  output: z.object({ url: z.string(), filename: z.string() }),
};
